'use strict';

exports.__esModule = true;

var _axiosInterceptorsLoader = require('./axios-interceptors-loader');

var _axiosInterceptorsLoader2 = _interopRequireDefault(_axiosInterceptorsLoader);

var _axiosInterceptWixResult = require('./axios-intercept-wix-result');

var _axiosInterceptWixResult2 = _interopRequireDefault(_axiosInterceptWixResult);

var _axiosInterceptBaseurl = require('./axios-intercept-baseurl');

var _axiosInterceptBaseurl2 = _interopRequireDefault(_axiosInterceptBaseurl);

var _axiosInterceptMultilingual = require('./axios-intercept-multilingual');

var _axiosInterceptMultilingual2 = _interopRequireDefault(_axiosInterceptMultilingual);

var _axiosInterceptArtifactid = require('./axios-intercept-artifactid');

var _axiosInterceptArtifactid2 = _interopRequireDefault(_axiosInterceptArtifactid);

var _axiosInterceptSiteRevision = require('./axios-intercept-site-revision');

var _axiosInterceptSiteRevision2 = _interopRequireDefault(_axiosInterceptSiteRevision);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _defaults = {
  loadInterceptors: true
};

exports.default = function (axios, _ref) {
  var baseURL = _ref.baseURL,
      _ref$loadInterceptors = _ref.loadInterceptors,
      loadInterceptors = _ref$loadInterceptors === undefined ? _defaults.loadInterceptors : _ref$loadInterceptors,
      lang = _ref.lang,
      locale = _ref.locale,
      isPrimaryLanguage = _ref.isPrimaryLanguage,
      siteInstance = _ref.siteInstance,
      wixCodeApi = _ref.wixCodeApi;

  axios.defaults.baseURL = baseURL;

  return _axiosInterceptorsLoader2.default.loadIfNeeded(axios, {
    shouldLoadInterceptors: loadInterceptors,
    interceptors: [_axiosInterceptWixResult2.default, _axiosInterceptBaseurl2.default, _axiosInterceptMultilingual2.default.getInterceptor({
      lang: lang,
      siteInstance: siteInstance,
      locale: locale,
      isPrimaryLanguage: isPrimaryLanguage
    }), _axiosInterceptArtifactid2.default, _axiosInterceptSiteRevision2.default.getInterceptor({ wixCodeApi: wixCodeApi })]
  });
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-axios-config/dist/src/wix-axios-config.js
// module id = 1429
// module chunks = 0